<template>
    <div class="content">
        <div class="header">{{ data.enterpriseName ? data.enterpriseName : data.name }}</div>
        <div class="close" @click="$emit('cancel')"><CloseCircleOutlined /></div>
        <div class="text" v-if="type === 'cooperatives' || type === 'services'">
            <p><span>主体名称：</span>{{ data.enterpriseName }}</p>
            <p><span>所在镇街：</span>{{ data.town }}</p>
            <p><span>联系人：</span>{{ data.name }}</p>
            <p><span>联系电话：</span>{{ data.phone }}</p>
            <p><span>联系地址：</span>{{ data.address }}</p>
            <p v-if="data.description">
                <span>企业简介：</span>
                <a-tooltip placement="rightTop" v-if="data.description.length > 19">
                    <template #title>{{ data.description }}</template>
                    {{ data.description ? data.description.substr(0,18) + '...' : '' }}
                </a-tooltip>
                <template v-else>{{ data.description }}</template>
            </p>
        </div>
        <div class="text" v-else-if="type === 'information'">
            <p><span>主体名称：</span>{{ data.name }}</p>
            <p><span>所在镇街：</span>{{ data.town }}</p>
            <p><span>联系人：</span>{{ data.nickname }}</p>
            <p><span>联系电话：</span>{{ data.phone }}</p>
            <p><span>联系地址：</span>{{ data.address }}</p>
        </div>
        <div class="text" v-else-if="type === 'homes'">
            <p><span>主体名称：</span>{{ data.enterpriseName }}</p>
            <p><span>所在镇街：</span>{{ data.town }}</p>
            <p><span>联系人：</span>{{ data.name }}</p>
            <p><span>联系地址：</span>{{ data.address }}</p>
        </div>
        <div class="text" v-else-if="type === 'dragon'">
            <p><span>主体名称：</span>{{ data.enterpriseName }}</p>
            <p><span>企业等级：</span><span style="color: #e8973e; font-weight: bold">{{ data.remark }}</span></p>
            <p><span>所在镇街：</span>{{ data.town }}</p>
            <p><span>联系人：</span>{{ data.name }}</p>
            <p><span>联系电话：</span>{{ data.phone }}</p>
            <p><span>联系地址：</span>{{ data.address }}</p>
            <p>
                <span>企业简介：</span>
                <a-tooltip placement="right">
                    <template #title>{{ data.description }}</template>
                    {{ data.description ? data.description.substr(0,18) + '...' : '' }}
                </a-tooltip>
            </p>
        </div>
    </div>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
import { ref } from 'vue'
export default {
    name: "infoBox",
    setup() {
        const data = ref({})
        const type = ref('')
        return {
            data,
            type
        }
    },
    methods: {
        setData(data, type) {
            this.type = type
            if (type === 'information') {
                data.town = this.getTownName(data.parentid)
            }
            this.data = data
        },
        getTownName(id) {
            const idList = {
                1: '商河',
                2: '许商街道',
                3: '殷巷镇',
                4: '怀仁镇',
                5: '龙桑寺镇',
                6: '郑路镇',
                7: '贾庄镇',
                8: '玉皇庙镇',
                9: '白桥镇',
                10: '孙集镇',
                11: '韩庙镇',
                12: '沙河镇',
                13: '张坊镇'
            }
            return idList[id]
        }
    },
    components: {
        CloseCircleOutlined
    }
}
</script>

<style scoped lang="stylus">
    .content {
        width 760px
        height 490px
        position fixed
        top 250px
        left calc(50% - 370px)
        z-index 1
        background-image url("../../../assets/img/infoBox_bg.png")
        background-size 100% 100%
        background-repeat no-repeat
        .header {
            width 100%
            height 80px
            line-height 80px
            padding-left 70px
            font-size 24px
            color #FFF
        }
        .close {
            position absolute
            top 30px
            right 60px
            color #fff
            font-size 25px
            cursor pointer
        }
        .text {
            padding 35px 60px
            font-size 24px
            color #FFF
        }
        .text p {
            margin 8px 0
            width 100%
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
        }
        .text p span:first-child {
            color #3EF5FC
            display inline-block
            min-width 130px
        }
    }
</style>